<template>
  <div class="alarm">
    <div class="title" style="width: 40%;">
      <div class="title-text">设备报警</div>
    </div>
    <table>
      <thead>
        <tr>
          <td></td>
          <td>设备编号</td>
          <td>设备位置</td>
          <td>报警内容</td>
          <td>报警时间</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>AK001</td>
          <td>A区电子围栏</td>
          <td class="done">离线</td>
          <td>2022.04.18</td>
        </tr>
        <tr>
          <td>AK002</td>
          <td>C区电子围栏</td>
          <td class="fault">故障</td>
          <td>2022.04.19</td>
        </tr>
        <tr>
          <td>AK003</td>
          <td>C区电子围栏</td>
          <td class="done">离线</td>
          <td>2022.04.20</td>
        </tr>
        <tr>
          <td>AK004</td>
          <td>C区电子围栏</td>
          <td class="fault">故障</td>
          <td>2022.04.21</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  components: {

  },
  methods: {

  },

}
</script>

<style scoped lang="less">
.alarm {
  height: 90%;
  width: 35%;
  table {
    width: 100%;
    color: #FFFFFF;
    font-family: '微软雅黑';
    border-collapse: collapse;
    font-size: 12px;
    text-align: center;
    margin-top: 1vh;
    td {
      padding: 8px 0;
    }
    thead {
      background-color: rgba(152, 254, 249, 0.302);
      width: 100%;
    }
    tbody {
      tr {
        border-bottom: 1px dashed rgba(152, 254, 249, 0.8);
        position: relative;
        &::before{
          content: '';
          width: 10%;
          height: 3px;
          position: absolute;
          background-color: rgb(152, 254, 249);
          bottom: -3px;
          left: 0;
        }
        &::after{
          content: '';
          width: 10%;
          height: 3px;
          position: absolute;
          background-color: rgb(152, 254, 249);
          bottom: -3px;
          right: 0;
        }
        td {
          &.done {
            color: rgb(48, 199, 77);
          }
          &.fault{
            color: #f39104;;
          }
        }
      }
    }
  }
}
</style>
